var _DomainActionsErrorsM, _DomainActionsErrorsM2, _DomainActionsErrorsM3;
import { Box } from '@wix/design-system';
import { DomainActionsErrorsMap, DomainSearchSuiteModule, SearchRecommendationModule } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { GeneralAnonymousOverride, SubdomainRootTaken } from '../../../Components';
import { AnonymousFooter } from '../../../Components/AnonymousFooter/AnonymousFooter';
import { AnonymousResultsHeader } from '../../../Components/Headers';
import { BackButton } from '../../../Components/Headers/HeaderWrapper';
import { TldListVoucherBanner } from '../../../Components/VoucherBanner';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { TldListPricingContent } from './TldListPricingContent';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { useIsWixHpReferral } from '../../../hooks/useIsWixHpReferral';
import { useRecommendations } from '../../../hooks/useRecommendations';
import { useResultsBack } from '../../../hooks/useResultsBack';
import { useSettledMethods } from '../../../hooks/useSettledMethod';
import { ANONYMOUS_SETTLEMENTS } from '../../../utils/anonymousSettlements';
import { ResultsLayout, ResultsRecommendations, ResultsSearchBar } from '../../ResultsLayout';
import s from '../../anonymousResultsPage.scss';
const customConfiguration = {
  ...(((_DomainActionsErrorsM = DomainActionsErrorsMap.connect) == null ? void 0 : _DomainActionsErrorsM.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM2 = DomainActionsErrorsMap.assign) == null ? void 0 : _DomainActionsErrorsM2.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  ...(((_DomainActionsErrorsM3 = DomainActionsErrorsMap.transfer) == null ? void 0 : _DomainActionsErrorsM3.reduce((acc, status) => ({
    ...acc,
    [status]: GeneralAnonymousOverride
  }), {})) ?? {}),
  transfer: GeneralAnonymousOverride,
  connect: GeneralAnonymousOverride,
  subdomainRootIsNotConnected: SubdomainRootTaken,
  domainTakenInWix: GeneralAnonymousOverride,
  subdomainTakenInWix: SubdomainRootTaken,
  noStatus: GeneralAnonymousOverride
};
export const TldListResultsPage = _ref => {
  let handlers = _ref.handlers,
    externalViewer = _ref.externalViewer,
    deviceType = _ref.deviceType,
    showCartHeader = _ref.showCartHeader;
  useSettledMethods(ANONYMOUS_SETTLEMENTS);
  return /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    actions: {
      siteInfo: {
        externalViewer: Boolean(externalViewer)
      },
      handlers,
      resolveCorrectedDomains: false
    },
    statusesCustomComponents: {
      customConfiguration
    }
  }, /*#__PURE__*/React.createElement(TldListResultsPageContent, {
    deviceType: deviceType,
    showCartHeader: showCartHeader
  }))));
};
export const TldListResultsPageContent = _ref2 => {
  let deviceType = _ref2.deviceType,
    _ref2$showCartHeader = _ref2.showCartHeader,
    showCartHeader = _ref2$showCartHeader === void 0 ? false : _ref2$showCartHeader;
  const isMobile = useIsMobile();
  const isWixHpReferral = useIsWixHpReferral();
  const isWixHpMobile = isMobile && isWixHpReferral;
  const handleBackClick = useResultsBack();
  const contentClassName = s.centeredContent;
  const _useRecommendations = useRecommendations({
      enableOnEmptyQuery: false
    }),
    taxesNotIncluded = _useRecommendations.taxesNotIncluded;
  return /*#__PURE__*/React.createElement(ResultsLayout, {
    biViewMode: "Storefront",
    querySubmitPath: "/",
    deviceType: deviceType,
    showCartHeader: showCartHeader,
    hideSearchBarShadowOnPartialMatch: true,
    showSearchIcon: true,
    hideFilterChips: true,
    useCompactRecommendationsLayout: true,
    voucherPlacement: "outsideStickyHeader",
    optimizedSearchBarStyle: true,
    searchBar: /*#__PURE__*/React.createElement(ResultsSearchBar, {
      isWixHpMobile: isWixHpMobile
    }),
    header: /*#__PURE__*/React.createElement(AnonymousResultsHeader, {
      onBackClick: isMobile ? undefined : handleBackClick,
      hideTrustBuilders: true
    }),
    voucher: /*#__PURE__*/React.createElement(TldListVoucherBanner, null),
    footer: /*#__PURE__*/React.createElement(Box, {
      gridArea: "footer",
      padding: "SP6 48px",
      className: contentClassName,
      textAlign: "center",
      align: "center"
    }, /*#__PURE__*/React.createElement(AnonymousFooter, {
      taxesNotIncluded: taxesNotIncluded
    })),
    mobileBackButton: isWixHpMobile ? undefined : /*#__PURE__*/React.createElement(Box, {
      width: "100%"
    }, /*#__PURE__*/React.createElement(BackButton, {
      onClick: handleBackClick
    }))
  }, /*#__PURE__*/React.createElement(SearchRecommendationModule.Provider, {
    Layouts: {
      customConfiguration: {
        PricingContent: TldListPricingContent
      }
    }
  }, /*#__PURE__*/React.createElement(ResultsRecommendations, {
    showHeroCard: true,
    hideExactMatchHeadline: true,
    className: contentClassName,
    emptyState: isWixHpMobile ? /*#__PURE__*/React.createElement(React.Fragment, null) : undefined,
    Layouts: {
      PricingContent: TldListPricingContent
    }
  })));
};
//# sourceMappingURL=TldListResultsPage.js.map